<template>
  <tr :class="classObject">
    <td>
      <div class="form-group mb-0">
        <bs-select
          :name="index + '_site_id'"
          classname="js-select2"
          :options="
            $_.sortBy(
              sites.map((site) => {
                return {
                  name: site.name,
                  value: site.id,
                };
              }),
              'name'
            )
          "
          v-model="link.site_id"
          :disabled="added || !$_.isEmpty(package)"
          :errorOnTouch="true"
        ></bs-select>
      </div>
    </td>
    <td>
      <div class="form-group mb-0">
        <bs-select
          :name="index + '_page_id'"
          classname="js-select2"
          :options="
            pages.map((item) => {
              return {
                value: item.id,
                name: $options.filters.capitalize(item.title),
              };
            })
          "
          :disabled="(!link.site_id && !pages.length) || pages.length === 0 || added || !$_.isEmpty(package)"
          v-model="link.page_id"
          :errorOnTouch="true"
        ></bs-select>
      </div>
    </td>
    <td>
      <div class="form-group mb-0">
        <bs-select
          :name="index + '_category_id'"
          classname="js-select2"
          :options="
            categories.map((item) => {
              return {
                value: item.id,
                name: $options.filters.capitalize(item.title),
              };
            })
          "
          :disabled="(!link.page_id && !categories.length) || categories.length === 0 || added"
          v-model="link.category_id"
          :errorOnTouch="true"
        ></bs-select>
      </div>
    </td>
    <td>
      <div class="form-group mb-0">
        <bs-input
          :name="index + '_title'"
          classname="js-maxlength"
          maxlength="42"
          :maxlengthShow="true"
          v-model="link.title"
          placeholder="Vul hier de link titel in"
          :disabled="added"
          :errorOnTouch="true"
        ></bs-input>
      </div>
    </td>
    <td>
      <div class="form-group mb-0">
        <bs-input :name="index + '_url'" v-model="link.url" placeholder="Vul hier de link url in" :disabled="added" :errorOnTouch="true"></bs-input>
      </div>
    </td>
    <td>
      <div class="form-group mb-0">
        <bs-input
          :name="'start_date_' + index"
          classname="js-flatpickr flatpickr-input bg-white"
          :minDate="moment().format('YYYY-MM-DD')"
          v-model="link.start_date"
          placeholder="Vul hier de link start datum in"
          :disabled="added"
          :errorOnTouch="true"
        ></bs-input>
      </div>
    </td>
    <td v-if="$_.isEmpty(package)">
      <span v-if="link.page_id">{{
        link.page_id == 1
          ? site.home_price_discount
            ? site.home_price_discount
            : site.home_price
          : site.daughter_price_discount
          ? site.daughter_price_discount
          : site.daughter_price | currency
      }}</span>
      <i
        v-show="link.page_id"
        class="fas fa-question-circle ml-2"
        data-toggle="tooltip"
        data-placement="top"
        title="Indien u gebruikerskorting heeft, wordt deze in de winkelwagen berekend"
        data-original-title="Indien u gebruikerskorting heeft, wordt deze in de winkelwagen berekend"
      ></i>
    </td>
    <td class="text-center" v-if="$_.isEmpty(package)">
      <a href="javascript:void(0)" class="text-danger" v-on:click="remove"><i class="fa fa-times"></i></a>
    </td>
  </tr>
</template>
<script>
import axios from 'axios';

export default {
  props: ['sites', 'link', 'index', 'added', 'errors', 'package'],
  data: () => {
    return {
      site: null,
      valid: false,
      pages: [],
      categories: [],
    };
  },
  computed: {
    classObject: function() {
      return {
        'table-success': (this.valid && !this.errors) || this.added,
        'table-danger': !this.valid && this.errors && !_.isEmpty(this.errors),
      };
    },
  },
  mounted: function() {
    setTimeout(() => {
      window.One.helpers(['core-bootstrap-tooltip']);
    }, 1000);
  },
  watch: {
    link: {
      deep: true,
      handler: function() {
        document.querySelector(`#start_date_${this.index}`)._flatpickr.redraw();
        let emptyValues = Object.values(this.link).filter((x) => x === null || x === '');
        this.valid = emptyValues.length === 0;
      },
    },
    'link.site_id': {
      immediate: true,
      handler: function(newValue, oldValue) {
        this.site = null;
        this.pages = [];
        this.categories = [];

        if (_.isEmpty(this.package) && oldValue !== undefined && !this.link.imported) {
          this.link.page_id = null;
          this.link.category_id = null;
        }

        if (this.link.site_id) {
          this.site = this.sites.find((site) => {
            return site.id == this.link.site_id;
          });
          axios.get(route('sites.pages.index', this.link.site_id)).then((response) => {
            if (response.status == 200 && response.data) {
              if (response.data.success) {
                this.pages = response.data.data;
                if (this.link.page_id) {
                  this.categories = this.pages.find((page) => page.id == this.link.page_id).categories;
                }
              }
            }
          });
        }
      },
    },
    'link.page_id': {
      immediate: true,
      handler: function() {
        var self = this;
        this.categories = [];
        if (this.link.site_id && this.link.page_id && this.pages.length > 0) {
          this.link.category_id = null;
          this.categories = this.pages.find((page) => page.id == this.link.page_id).categories;
        }
      },
    },
  },
  methods: {
    remove: function() {
      this.$emit('removeRow', this.index);
    },
  },
};
</script>
